module.exports = __webpack_public_path__ + "media/images/icons/sausage-bff21700d927f89732170aaf323ca3d5.png";